import type { RuleHandler } from "../types";

const checkTimesAllowedToCompletePerEvent: RuleHandler = (
  context,
  requirement,
) => {
  const {
    timesAllowedToCompletePerEvent,
    timesAllowedToCompletePerEventFilter: perEventFilter,
  } = requirement.userDrivenAttributes!;

  if (!perEventFilter || !timesAllowedToCompletePerEvent) return false;

  const currentUsages =
    context.allocation?.attributes?.eventIdUsages?.[
      context.selection.eventIds[0]
    ] || 0;

  return currentUsages < timesAllowedToCompletePerEvent;
};

export { checkTimesAllowedToCompletePerEvent };
